/* :: Import Dependencies
{+} ---------------------------------- */
import barba from '@barba/core';
import '@ryangjchandler/spruce';
import 'alpine-magic-helpers';
import 'alpinejs';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/* :: Set Globals
{+} ---------------------------------- */
global.gsap = gsap;
global.ScrollTrigger = ScrollTrigger;

/* :: Import Local
{+} ---------------------------------- */
// :: Modules ------------ //
import lightboxVideo from '@/modules/LightboxVideo.js';
import header from '@/modules/Header.js';
import sliders from '@/modules/Sliders.js';
import video from '@/modules/Video.js';

// :: Components ------------ //
import avalanche from '@/components/avalanche/Avalanche.js';
import states from '@/components/States.js';
import background from '@/components/Background.js';

// :: Blocks
import fiftyFifty from '@/blocks/FiftyFifty.js';
import instagram from '@/blocks/Instagram.js';
import jobs from '@/blocks/Jobs.js';
 
// :: Page Transitions ------------ //
import primaryOnce from '@/modules/pageTransitions/PrimaryOnce.js';
import primaryLeave from '@/modules/pageTransitions/PrimaryLeave.js';
import primaryEnter from '@/modules/pageTransitions/PrimaryEnter.js';
import primaryOnceLeave from '@/modules/pageTransitions/PrimaryOnceLeave.js';

console.log(
    `%cCrafted with ❤ by https://whiteboard.is`,
    'background: #D14124; color: #ffffff; font-size: 13px; padding: 4px 8px;'
);

// π ----
// :: 🌲 SPRUCE ---------------------------::
// ____
window.Spruce.store('site', {
    animationDelay: 0.3,
    enterDelay: 2.8
});

window.Spruce.store('nav', {
    open: false
});

window.Spruce.store('lightboxVideo', {
    open: false,
    source: '',
    videoID: '',
    mp4: '',
    webm: '',
    poster: ''
});

// π ----
// :: ⛰ ALPINE ---------------------------::
// ____

// :: Modules ------------ //
window.lightboxVideo = lightboxVideo;
window.header = header;
window.videoPlayer = video;
window.sliders = sliders;
window.instagram = instagram;
window.jobs = jobs;
window.fiftyFifty = fiftyFifty;
window.states = states;
window.background = background;

// :: Components ------------ //
avalanche();
states();

// :: Blocks ------------ //
fiftyFifty();
instagram();
jobs();

// π ----
// :: PAGE TRANSITIONS ---------------------------::
// ____
barba.hooks.afterEnter(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
        // Handle anchor scroll manually
        if (window.location.hash) {
            const anchor = document.querySelector(window.location.hash);
            if (anchor) {
                anchor.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, 200);
    ScrollTrigger.refresh();
});

barba.hooks.afterLeave(() => {
    Spruce.reset('site', {
        enterDelay: 0 
    });

    Spruce.reset('nav', {
        open: false
    });
});

barba.hooks.after(() => {
    ga('set', 'page', window.location.pathname);
    ga('send', 'pageview');
});

if (history.scrollRestoration) {
    history.scrollRestoration = 'manual';
}

barba.init({
    timeout: 10000,
    prevent: ({ el }) => el.classList && el.classList.contains('no-transition'),
    transitions: [
        {
            once({ next }) {
                primaryOnce();
            },
            leave({ current }) {
                const done = this.async();

                primaryLeave(current.container, done);
            },
            onceLeave({ current }) {
                const done = this.async();

                primaryOnceLeave(current.container, done);
            },
            enter({ next }) {
                primaryEnter();
            }

        }
    ],
    schema: {
        prefix: 'data-portal',
        wrapper: 'realm',
        container: 'destination'
    }
});
